<template>
  <router-view v-wechat-title="$route.meta.title" />
</template>
<script>

export default {
  name: 'App',
  components: {}
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
ul,li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
</style>
